export default {
    lookout: {
        name: "Lookout",
        url: "nwcg_ops/lookout",
    },
}
